import React from 'react'
import {BsDatabaseFillLock} from 'react-icons/bs'
import Table from 'react-bootstrap/Table'
import './AuditList.css'
import FormFields from './FormFields'
import moment from 'moment'

function AuditList(props) {

    // console.log("AuditList props", props)
    const columns = [
        { header: "Audit Date", val: "updated_at", },
        { header: "User", val: "added_by_userid", },
        { header: "Record Type", val: "record_type", },
        // { header: "Changed Attribute", val: "changed_attribute", },
        { header: "Event Details", val: "changed_attribute", },
    ]
    const fields = FormFields()

    // props.auditItems.map((aud, audix) => {
    //     console.log("audit records", aud)
    // })

    const ChangeDetails = (props) => {

        let changes = {}
        if (!!props.audrec.changed_attribute) {
          try {
              // sometimes audrec.changed_attribute comes in all uppercase, including null as NULL. That causes json parsing to fail
              // check for NULL and convert it to null before parsing 
              // also instead of old/new keys there might be OLD/NEW keys - we take care of it below (after parsing)
              changes = JSON.parse(props.audrec.changed_attribute.replace(/\bNULL\b/gi, 'null'));
              // console.log("changes", changes)
          }
          catch {
              console.log("Audit List - error parsing changed_attribute ", props.audrec.changed_attribute)
              changes = {}
          }
        }
        

        if (changes === null) {
            return <td></td>
        }
        // console.log("changes", changes)

        let keys = Object.keys(changes)
        // populate new object that only has real changes
        let realChanges = {}
        keys.forEach(k => {
            let oldval = changes[k]?.old || changes[k]?.OLD
            let newval = changes[k]?.new ||changes[k]?.NEW
            // console.log("looking for changes - k, oldval, typeof(oldval), newval, typeof(newval)", k, oldval, typeof(oldval), newval, typeof(newval))
            if (typeof(oldval) == 'boolean' || typeof(newval) == 'boolean') {
                if ((!!oldval) !== (!!newval)) {
                    realChanges[k] = {old: String(!!oldval), new: String(!!newval)}
                } 
            } else if (typeof(oldval) == 'number' || typeof(newval) == 'number') {
                if ((oldval?? 0) !== (newval?? 0)) {
                    realChanges[k] = {old: oldval?? '<empty>', new: newval?? '<empty>'}
                }
            } else if (typeof(oldval) == 'string' || typeof(newval) == 'string') {
                // console.log("oldval?? '', newval?? ''", oldval?? '', newval?? '')
                // console.log("oldval?? '' !== newval?? ''", (oldval?? '') !== (newval?? ''))
                if ((oldval?? '') !== (newval?? '')) {
                    realChanges[k] = {old: !!oldval ? oldval : '<empty>', new: !!newval ? newval : '<empty>'}
                    // console.log("Real Changes[k]", k, realChanges[k])
                }
            }
        })

        // console.log("real changes", realChanges)
        keys = Object.keys(realChanges)

        // console.log("real changes keys", keys)

        if (keys.length > 0) {
            return (
                <td className='audit-recs-td'>
                    <div>
                    {keys.map((k,kix) => {
                        return (
                        <div key={kix} >
                            <span className='audit-recs-attr text-primary'>{fields.find(f => f.name === k)?.display_name?? k}</span> changed from <span className='audit-recs-old'>{realChanges[k].old}</span> to <span className='audit-recs-new'>{realChanges[k].new}</span>
                        </div>
                        )
                    })}
                    </div>
                </td>
            )
        } else {
            return <td></td>
        }
        
    }

    return (
        <div className={`audit-recs ${props.auditItems.length > 0 ? 'audit-recs-with-data':''}`}>
            <div className='d-flex justify-content-between audit-recs-toolbar'>
                <div className='inline-block text-left'>
                    <BsDatabaseFillLock className='audit-recs-icon' />
                        Audit Records
                </div>
            </div>

            <Table responsive>
                <thead>
                    <tr>
                        {columns.map((col, index) => (
                            
                            <th key={index}>{col.header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {props.auditItems.map((aud, audix) => {
                        return (
                        <tr key={audix}>
                            <td className='audit-recs-td'>{moment.utc(new Date(aud.updated_at)).startOf('second').format('YYYY-MM-DD hh:mm:ss a')}</td>
                            <td className='audit-recs-td'>{aud.added_by_user}</td>
                            <td className='audit-recs-td'>{aud.record_type}</td>
                            <ChangeDetails audrec={aud} ix={audix}  />
                        </tr>
                        )
                    })}
                </tbody>
            </Table>
        </div>
    )
}

export default AuditList
